import React, { useEffect, useState } from "react";
import "./Performance.css";

const Performance = () => {
  //////////////////////// CONVERSION RATE START ////////////////////////
  const [ConversionRate, setConversionRate] = useState([]);

  const fetchConversionRate = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/ConversionRate");
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();

      // Debugging statements
      console.log("Fetched data:", data);
      console.log("Reversed data:", data.reverse());

      setConversionRate(data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchConversionRate();
  }, []);
  //////////////////////// CONVERSION RATE END  ////////////////////////

  //////////////////////// Refund RATE START ///////////////////////

  const [RefundRate, setRefundRate] = useState([]);

  const fetchRefundRate = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/aggregateDataMain");
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();

      // Debugging statements
      console.log("Fetched data:", data);
      console.log("Reversed data:", data.reverse());

      setRefundRate(data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchRefundRate();
  }, []);

  //////////////////////// Refund RATE END  ////////////////////////
  //////////////////////// ClassBookedCanceled RATE START ///////////////////////

  const [ClassBookedCanceledRate, setClassBookedCanceledRate] = useState([]);

  const fetchClassBookedCanceledRate = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/ClassBookedDataMainProcessing");
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();

      // Debugging statements
      console.log("Fetched data:", data);
      console.log("Reversed data:", data.reverse());

      setClassBookedCanceledRate(data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchClassBookedCanceledRate();
  }, []);

  //////////////////////// ClassBookedCanceled RATE END  ////////////////////////
  //////////////////////// ClassBookedCanceled RATE START ///////////////////////

  const [LeadsApprovalMainRate, setLeadsApprovalMainRate] = useState([]);

  const fetchLeadsApprovalMainRate = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/leadsApprovalMain");
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();

      // Debugging statements
      console.log("Fetched data:", data);
      console.log("Reversed data:", data.reverse());

      setLeadsApprovalMainRate(data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchLeadsApprovalMainRate();
  }, []);

  //////////////////////// LeadsApprovalMain RATE END  ////////////////////////

  //////////////////////// PROCESSING SPEED RATE START ///////////////////////

  const [ProcessingSpeed, setProcessingSpeed] = useState([]);

  const fetchProcessingSpeed = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/ProcessingSpeed");
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();

      // Debugging statements
      console.log("Fetched data:", data);
      console.log("Reversed data:", data.reverse());

      setProcessingSpeed(data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchProcessingSpeed();
  }, []);

  //////////////////////// PROCESSING SPEED END  /////////////////////////////

  //////////////////////// LeadConfirmation SPEED RATE START ///////////////////////

  const [LeadConfirmationSpeed, setLeadConfirmationSpeed] = useState([]);

  const fetchLeadConfirmationSpeed = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/leadConfirmationSpeed");
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();

      // Debugging statements
      console.log("Fetched data:", data);
      console.log("Reversed data:", data.reverse());

      setLeadConfirmationSpeed(data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchLeadConfirmationSpeed();
  }, []);

  //////////////////////// LeadConfirmation SPEED END  ////////////////////////

    //////////////////////// PaymentCollections SPEED RATE START ///////////////////////

    const [PaymentCollectionsSpeed, setPaymentCollectionsSpeed] = useState([]);

    const fetchPaymentCollectionsSpeed = async () => {
      try {
        const response = await fetch("https://tutor-tree-server-1.vercel.app/PaymentCollectionSpeed");
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
  
        // Debugging statements
        console.log("Fetched data:", data);
        console.log("Reversed data:", data.reverse());
  
        setPaymentCollectionsSpeed(data.reverse());
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    useEffect(() => {
      fetchPaymentCollectionsSpeed();
    }, []);
  
    //////////////////////// PaymentCollections SPEED END  ////////////////////////

  return (
    <div>
      <div className="w-full h-32 flex justify-center items-center bg-gray-50">
        <h2 className='headingTxt'>Performance</h2>
      </div>
      <div className="grid grid-cols-3 gap-5 m-5">
        {/* 1 */}
        <div className="flex justify-between px-5 shadow-md rounded-sm border border-gray-50 py-2">
          {ConversionRate.map((con) => (
            <div className=" w-32 flex flex-col justify-center items-center">
              <div className="w-28  m-1">
              <h1 className="textBox">Conversion Rate</h1>
              </div>
              <div className="w-28  m-1">
                <h1 className="textBoxNumber">{con.totalPercentage} %</h1>
              </div>
              <div className="w-28 m-1">
                <h1 className="textBox">
                  {con.sentInvoiceData} out of {con.publishData}{" "}
                </h1>
              </div>
            </div>
          ))}
          <div className="flex justify-center items-center">
            {ConversionRate.map((con, index) => (
              <div key={index} className="relative size-40">
                <div
                  className="radial-progress bg-gray-50 text-orange-500"
                  style={{
                    "--value": `${con.totalPercentage}`,
                    "--size": "5rem",
                    "--thickness": "10px",
                  }}
                  role="progressbar"
                >
                  <h1 className="textPer">{con.totalPercentage} %</h1>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* 2 */}
        {RefundRate.map((refund) => (
          <div className="flex justify-between px-5 shadow-md rounded-sm border border-gray-50 py-2">
            <div className=" w-32 flex flex-col justify-center items-center">
              <div className="w-28  m-1">
                <h1 className="textBox">Refund Rate</h1>
              </div>
              <div className="w-28  m-1">
                <h1 className="textBoxNumber">{refund.refundedPercentage}%</h1>
              </div>
              <div className="w-28 m-1">
                <h1 className="textBox">
                {refund.totalRefunded}  out of {refund.totalEntries}
                </h1>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <div
                className="radial-progress bg-gray-50 text-orange-500"
                style={{
                  "--value": `${refund.refundedPercentage}`,
                  "--size": "5rem",
                  "--thickness": "10px",
                }}
                role="progressbar"
              >
                <h1 className="textPer">{refund.refundedPercentage} %</h1>
              </div>
            </div>
          </div>
        ))}
        {/* 3 */}
        {
          ClassBookedCanceledRate.map(cancel =>
            <div className="flex justify-between px-5 shadow-md rounded-sm border border-gray-50 py-2">
            <div className=" w-32 flex flex-col justify-center items-center">
              <div className="w-28  m-1">
                <h1 className="textBox">Tutors Cancelled After Trial Classes</h1>
              </div>
              <div className="w-28  m-1">
                <h1 className="textBoxNumber">{cancel.cancelledPercentage}%</h1>
              </div>
              <div className="w-28 m-1">
                <h1 className="textBox">{cancel.totalCancelled} out of {cancel.totalClassBooked}</h1>
              </div>
            </div>
            <div className="flex justify-center items-center">
            <div
                className="radial-progress bg-gray-50 text-orange-500"
                style={{
                  "--value": `${cancel.cancelledPercentage}`,
                  "--size": "5rem",
                  "--thickness": "10px",
                }}
                role="progressbar"
              >
                <h1 className="textPer">{cancel.cancelledPercentage} %</h1>
              </div>
            </div>
          </div>  
          )
        }
        {/* card4 */}
        {
          LeadsApprovalMainRate.map(lead=> 
            <div className="flex justify-between px-5 shadow-md rounded-sm border border-gray-50 py-2">
            <div className=" w-32 flex flex-col justify-center items-center">
              <div className="w-28  m-1">
                <h1 className="textBox">Lead Approval Rate</h1>
              </div>
              <div className="w-28  m-1">
                <h1 className="textBoxNumber">{lead.publishPercentage}%</h1>
              </div>
              <div className="w-28 m-1">
                <h1 className="textBox">{lead.totalPublished} out of {lead.totalAllJobs}</h1>
              </div>
            </div>
            <div className="flex justify-center items-center">
            <div
                className="radial-progress bg-gray-50 text-orange-500"
                style={{
                  "--value": `${lead.publishPercentage}`,
                  "--size": "5rem",
                  "--thickness": "10px",
                }}
                role="progressbar"
              >
                <h1 className="textPer">{lead.publishPercentage} %</h1>
              </div>
            </div>
          </div>
            )
        }
        {/* card5 */}
        {/* <div className="flex justify-between px-5 shadow-md rounded-sm border border-gray-50 py-2">
          <div className=" w-32 flex flex-col justify-center items-center">
            <div className="w-28  m-1">
              <h1 className="textBox">Tutor Delivery Speed</h1>
            </div>
            <div className="w-28  m-1">
              <h1 className="textBoxNumber">80%</h1>
            </div>
            <div className="w-28 m-1">
              <h1 className="textBox">18 out of 22</h1>
            </div>
          </div>
          <div className="flex justify-center items-center">
            <div class="relative size-40">
              <svg
                class="size-full"
                width="100"
                height="100"
                viewBox="0 0 36 36"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="18"
                  cy="18"
                  r="12"
                  fill="none"
                  class="stroke-current text-gray-200 dark:text-gray-700"
                  stroke-width="7"
                ></circle>
                <g class="origin-center -rotate-90 transform">
                  <circle
                    cx="18"
                    cy="18"
                    r="12"
                    fill="none"
                    class="stroke-current text-blue-600 dark:text-blue-500"
                    stroke-width="7"
                    stroke-dasharray="100"
                    stroke-dashoffset="75"
                  ></circle>
                </g>
              </svg>
            </div>{" "}
          </div>
        </div> */}
        {/* card6 */}
        {
          ProcessingSpeed.map(pro =>
            <div className="flex justify-between px-5 shadow-md rounded-sm border border-gray-50 py-2">
            <div className=" w-32 flex flex-col justify-center items-center">
              <div className="w-28  m-1">
                <h1 className="textBox">Processing Speed</h1>
              </div>
              <div className="w-28  m-1">
                <h1 className="textBoxNumber">{pro.publishPercentage}%</h1>
              </div>
              <div className="w-28 m-1">
                <h1 className="textBox">{pro.totalClassBooked} out of {pro.totalPendingVarCon}</h1>
              </div>
            </div>
            <div className="flex justify-center items-center">
            <div
                className="radial-progress bg-gray-50 text-orange-500"
                style={{
                  "--value": `${pro.publishPercentage}`,
                  "--size": "5rem",
                  "--thickness": "10px",
                }}
                role="progressbar"
              >
                <h1 className="textPer">{pro.publishPercentage} %</h1>
              </div>
            </div>
          </div>  
          )
        }
        {/* card7 */}
        
       {
       LeadConfirmationSpeed.map(lead=>
       <div className="flex justify-between px-5 shadow-md rounded-sm border border-gray-50 py-2">
          <div className=" w-32 flex flex-col justify-center items-center">
            <div className="w-28  m-1">
              <h1 className="textBox">Lead Confirmation Speed</h1>
            </div>
            <div className="w-28  m-1">
              <h1 className="textBoxNumber">{lead.publishPercentage}%</h1>
            </div>
            <div className="w-28 m-1">
              <h1 className="textBox">{lead.totalPubFollow} out of {lead.totalAllTutors}</h1>
            </div>
          </div>
          <div className="flex justify-center items-center">
              <div
                className="radial-progress bg-gray-50 text-orange-500"
                style={{
                  "--value": `${lead.publishPercentage}`,
                  "--size": "5rem",
                  "--thickness": "10px",
                }}
                role="progressbar"
              >
                <h1 className="textPer">{lead.publishPercentage} %</h1>
              </div>
          </div>
        </div>
        )
       }

        {/* card8 */}
        {
         PaymentCollectionsSpeed.map(pay=>
         <div className="flex justify-between px-5 shadow-md rounded-sm border border-gray-50 py-2">
          <div className=" w-32 flex flex-col justify-center items-center">
            <div className="w-28  m-1">
              <h1 className="textBox">Payment Collection Speed</h1>
            </div>
            <div className="w-28  m-1">
              <h1 className="textBoxNumber">{pay.publishPercentage}%</h1>
            </div>
            <div className="w-28 m-1">
              <h1 className="textBox">18 out of 22</h1>
            </div>
          </div>
             <div className="flex justify-center items-center">
              <div
                className="radial-progress bg-gray-50 text-orange-500"
                style={{
                  "--value": `${pay.publishPercentage}`,
                  "--size": "5rem",
                  "--thickness": "10px",
                }}
                role="progressbar"
              >
                <h1 className="textPer">{pay.publishPercentage} %</h1>
              </div>
          </div>
        </div>
         )
        }
      </div>
    </div>
  );
};

export default Performance;
